<h2 mat-dialog-title>Observação sobre o candidato</h2>
<mat-dialog-content>
    <form [formGroup]="form">
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Observação do candidato</mat-label>
                <textarea formControlName="comment" matInput rows="10"></textarea>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="submitting" color="primary" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submitting">
    <button mat-button mat-dialog-close color="accent">Fechar</button>
    <button mat-raised-button (click)="submit()" color="primary">Salvar</button>
</mat-dialog-actions>
